<template>
    <l-control ref="con" position="topright">
        <b-button @click="handleClick" 
            class="shadow-lg" 
            variant="dark"
        >
            <img src="../assets/interface/crosshair.svg" 
                class="mx-n1" 
                style="height:1.5em;filter:invert(90%)" 
            />
        </b-button>
    </l-control>
</template>

<script>
import { LControl } from 'vue2-leaflet'
import { mapGetters } from 'vuex'
export default {
    name: "UebersichtControlCenter",
    components: {
        LControl
    },
    computed: mapGetters(['user']),
    methods: {
        handleClick(){
            this.$parent.mapObject.setView(this.user.adresse)
        }
    }
}
</script>